/* cardframes — Kunden-Konfigurator.
 *
 * Zeigt Rahmenformat, Farbe und Bestückung, rechnet die Anordnung über
 * CardframesLayout und legt das Ergebnis in den Warenkorb.
 *
 * Das Vorschaubild ist bewusst schematisch: normierte Einheiten statt
 * Millimeter, ein einheitlicher Zierradius statt der echten Eckradien, keine
 * Maßangaben und kein Laserabzug. Es ist ein Produktbild, keine Schnittdatei.
 */
(function () {
  'use strict';

  const KATALOG = window.CARDFRAMES_KATALOG;
  if (!KATALOG) return;

  // Vom Liquid-Template gesetzt: { "<rahmen-id>|<farbe>": {id, preis} }.
  // Fehlt es (lokaler Entwurf), kommt der Preis aus dem Katalog und der
  // Kaufen-Knopf zeigt nur, was gesendet würde.
  const VARIANTEN = window.CARDFRAMES_VARIANTEN || null;

  // Versandkostenfrei-Hinweis. Vom Theme gesetzt, weil Betrag und Land dort
  // eingestellt werden: { ab: 30, land: 'DE' }. Ohne Angabe kein Hinweis.
  const VERSAND = window.CARDFRAMES_VERSAND || null;
  const LAND = window.CARDFRAMES_LAND || null;

  const RAND = KATALOG.regeln.rand;
  const STEG = KATALOG.regeln.steg;
  const ZIERRADIUS = 2.2; // normierte Einheiten, nicht die echten Radien
  const LEISTE = 7; // Breite der Rahmenleiste im Bild

  /* ---------- Sprache ---------- */

  const TEXTE = window.CARDFRAMES_TEXTE || {};
  const SPRACHEN = Object.keys(TEXTE);

  /* Reihenfolge: was das Theme vorgibt, dann die Shopsprache, dann das
   * Dokument, zuletzt der Browser. So folgt der Konfigurator im Shop
   * automatisch der Sprache der Seite. */
  function spracheErkennen() {
    const kandidaten = [
      window.CARDFRAMES_SPRACHE,
      window.Shopify && window.Shopify.locale,
      document.documentElement.lang,
      navigator.language,
    ];
    for (const k of kandidaten) {
      if (!k) continue;
      const kurz = String(k).toLowerCase().slice(0, 2);
      if (SPRACHEN.includes(kurz)) return kurz;
    }
    return SPRACHEN.includes('de') ? 'de' : SPRACHEN[0];
  }

  // Auf false setzen, wenn der Shop schon einen eigenen Sprachumschalter hat.
  const SPRACHWAHL =
    window.CARDFRAMES_SPRACHWAHL !== undefined ? window.CARDFRAMES_SPRACHWAHL : true;

  const zustand = {
    sprache: spracheErkennen(),
    rahmen: KATALOG.rahmen.find((f) => f.id === 'f30x40') || KATALOG.rahmen[0],
    querformat: false,
    farbe: KATALOG.farben[0],
    posten: [],
    drehungen: {},
  };

  /* Der Rahmen, wie er hängt. Querformat vertauscht Breite und Höhe — das ist
   * keine reine Ansichtssache, das Inlay wird dafür anders geschnitten. */
  function gehaengt(f) {
    const rahmen = f || zustand.rahmen;
    return zustand.querformat
      ? { id: rahmen.id, name: rahmen.name, preis: rahmen.preis, w: rahmen.h, h: rahmen.w }
      : rahmen;
  }

  /* Text holen und {platzhalter} ersetzen. */
  function T(schluessel, werte) {
    const satz = (TEXTE[zustand.sprache] || {})[schluessel];
    if (satz === undefined) return schluessel;
    if (!werte) return satz;
    return String(satz).replace(/\{(\w+)\}/g, (_, k) => (k in werte ? werte[k] : '{' + k + '}'));
  }

  const farbtext = (farbe) => {
    const tabelle = (TEXTE[zustand.sprache] || {}).farben || {};
    return tabelle[farbe.name] || farbe.name;
  };

  /* ---------- Rechnen ---------- */

  const euro = (n) => n.toFixed(2).replace('.', ',') + ' €';
  const halterVon = (id) => KATALOG.halter.find((h) => h.id === id);
  const istDunkel = () => Boolean(zustand.farbe.dunkel);
  // Schlüssel zur Shopify-Variante: Formatname und interner Farbname, genau
  // wie die Optionswerte am Produkt heißen. Nie die Übersetzung verwenden —
  // sonst fände der Warenkorb die Variante in keiner Fremdsprache mehr.
  const variantenschluessel = (f) => f.name + '|' + zustand.farbe.name;

  function anfragen() {
    return zustand.posten
      .filter((p) => p.anzahl > 0)
      .map((p) => ({ holder: halterVon(p.halterId), count: p.anzahl }));
  }

  function rechnen(rahmen) {
    return window.CardframesLayout.plan({
      frame: gehaengt(rahmen),
      requests: anfragen(),
      overrides: zustand.drehungen,
      margin: RAND,
      gap: STEG,
    });
  }

  function preisVon(f) {
    if (VARIANTEN) {
      const v = VARIANTEN[variantenschluessel(f)];
      if (v) return v.preis;
    }
    return f.preis;
  }

  /* ---------- Vorschaubild ---------- */

  /* Angedeutete Karte hinter dem Slab: heller Grund, ein Hauch der
   * Signalfarbe und ein Glanzstreifen. Keine echte Karte — nur genug Farbe,
   * dass der Rahmen lebendig wirkt. */
  function kartenbild(x, y, w, h, akzent) {
    const glanz =
      `M ${(x + w * 0.12).toFixed(2)} ${(y + h).toFixed(2)} ` +
      `L ${(x + w * 0.52).toFixed(2)} ${y.toFixed(2)} ` +
      `L ${(x + w * 0.74).toFixed(2)} ${y.toFixed(2)} ` +
      `L ${(x + w * 0.34).toFixed(2)} ${(y + h).toFixed(2)} Z`;
    return (
      `<g><rect x="${x.toFixed(2)}" y="${y.toFixed(2)}" width="${w.toFixed(2)}" ` +
      `height="${h.toFixed(2)}" rx="1" fill="#dcdde6"/>` +
      `<rect x="${x.toFixed(2)}" y="${y.toFixed(2)}" width="${w.toFixed(2)}" ` +
      `height="${h.toFixed(2)}" rx="1" fill="${akzent}" opacity="0.34"/>` +
      `<path d="${glanz}" fill="#ffffff" opacity="0.22"/>` +
      `<rect x="${x.toFixed(2)}" y="${y.toFixed(2)}" width="${w.toFixed(2)}" ` +
      `height="${h.toFixed(2)}" rx="1" fill="none" stroke="#00000018" stroke-width="0.25"/></g>`
    );
  }

  /* Eine Karte im Rahmen. Slabs bekommen den Labelstreifen oben, Magnetholder
   * die klare Hülle — damit man auf einen Blick sieht, was drin liegt. */
  function karteZeichnen(p, s) {
    const x = p.x * s + LEISTE;
    const y = p.y * s + LEISTE;
    const w = p.w * s;
    const h = p.h * s;
    const quer = p.rotated;
    const kurz = Math.min(w, h);
    const halter = halterVon(p.id);
    const slab = !halter || halter.art !== 'magnet';

    const teile = [
      `<g class="cfk__karte" data-key="${p.key}" tabindex="0" role="button" ` +
        `aria-label="${T('ariaDrehen', { name: p.label })}">`,
      `<rect x="${x.toFixed(2)}" y="${y.toFixed(2)}" width="${w.toFixed(2)}" height="${h.toFixed(2)}" ` +
        `rx="${ZIERRADIUS}" fill="url(#cfkKarte)" stroke="#00000022" stroke-width="0.3"/>`,
    ];

    const akzent = (halter && halter.farbe) || '#7b7b86';

    if (slab) {
      // Labelstreifen am kurzen Ende in der Signalfarbe des Graders, gedreht
      // sitzt er links. Bewusst nur Farbe und angedeutete Zeilen — die echten
      // Label-Designs sind fremde Aufmachung und werden nicht nachgebaut.
      const lb = quer ? kurz * 0.21 : w;
      const lh = quer ? h : kurz * 0.21;
      teile.push(
        `<path d="M ${x} ${y} h ${lb} v ${lh} h -${lb} Z" fill="${akzent}"/>`,
        `<rect x="${(x + (quer ? lb - 0.3 : 0)).toFixed(2)}" y="${(y + (quer ? 0 : lh - 0.3)).toFixed(2)}" ` +
          `width="${(quer ? 0.3 : w).toFixed(2)}" height="${(quer ? h : 0.3).toFixed(2)}" fill="#00000033"/>`
      );
      for (let i = 0; i < 2; i++) {
        const zx = quer ? x + lb * 0.3 : x + w * 0.16;
        const zy = quer ? y + h * 0.24 + i * h * 0.1 : y + lh * 0.3 + i * lh * 0.28;
        const zw = quer ? 0.7 : w * (i ? 0.4 : 0.68);
        const zh = quer ? h * (i ? 0.4 : 0.5) : 0.7;
        teile.push(
          `<rect x="${zx.toFixed(2)}" y="${zy.toFixed(2)}" width="${zw.toFixed(2)}" ` +
            `height="${zh.toFixed(2)}" rx="0.35" fill="#ffffff" opacity="0.72"/>`
        );
      }
      const fx = quer ? x + lb + kurz * 0.07 : x + w * 0.07;
      const fy = quer ? y + h * 0.07 : y + lh + kurz * 0.07;
      const fw = quer ? w - lb - kurz * 0.14 : w * 0.86;
      const fh = quer ? h * 0.86 : h - lh - kurz * 0.14;
      teile.push(kartenbild(fx, fy, fw, fh, akzent));
    } else {
      teile.push(
        kartenbild(x + kurz * 0.07, y + kurz * 0.07, w - kurz * 0.14, h - kurz * 0.14, akzent)
      );
    }

    // Plakette zum Drehen, damit klar ist, welche Karte man erwischt.
    const bx = x + kurz * 0.13;
    const by = y + kurz * 0.13;
    const br = Math.max(1.5, kurz * 0.1);
    teile.push(
      `<g class="cfk__dreher">`,
      `<circle cx="${bx.toFixed(2)}" cy="${by.toFixed(2)}" r="${br.toFixed(2)}" fill="#ee2761"/>`,
      `<text x="${bx.toFixed(2)}" y="${by.toFixed(2)}" font-size="${(br * 1.15).toFixed(2)}" ` +
        `fill="#fff" font-weight="700" text-anchor="middle" dominant-baseline="central" ` +
        `pointer-events="none">↻</text>`,
      `</g></g>`
    );
    return teile.join('');
  }

  function zeichnen(plan) {
    const f = gehaengt();
    // Auf 100 Einheiten Inlaybreite normieren: das Bild zeigt die Anordnung,
    // gibt aber keinen Maßstab preis.
    const s = 100 / f.w;
    const iH = f.h * s;
    const B = 100 + 2 * LEISTE;
    const H = iH + 2 * LEISTE;
    const dunkel = istDunkel();

    const teile = [
      `<svg viewBox="0 0 ${B} ${H.toFixed(2)}" role="img" ` +
        `aria-label="${T('ariaBild')}" xmlns="http://www.w3.org/2000/svg">`,
      `<defs>`,
      `<linearGradient id="cfkLeiste" x1="0" y1="0" x2="1" y2="1">` +
        `<stop offset="0" stop-color="${dunkel ? '#3a3a42' : '#ffffff'}"/>` +
        `<stop offset="0.5" stop-color="${dunkel ? '#1c1c21' : '#f2f2f5'}"/>` +
        `<stop offset="1" stop-color="${dunkel ? '#101014' : '#dedee4'}"/></linearGradient>`,
      `<linearGradient id="cfkKarte" x1="0" y1="0" x2="0.4" y2="1">` +
        `<stop offset="0" stop-color="#ffffff"/><stop offset="1" stop-color="#ececf1"/></linearGradient>`,
      `<filter id="cfkSchatten" x="-20%" y="-20%" width="140%" height="140%">` +
        `<feDropShadow dx="0" dy="1.4" stdDeviation="1.8" flood-color="#000" flood-opacity="0.22"/></filter>`,
      `</defs>`,
      `<rect x="0" y="0" width="${B}" height="${H.toFixed(2)}" rx="1" ` +
        `fill="url(#cfkLeiste)" filter="url(#cfkSchatten)"/>`,
      `<rect x="${LEISTE - 1}" y="${LEISTE - 1}" width="102" height="${(iH + 2).toFixed(2)}" ` +
        `fill="${dunkel ? '#08080a' : '#c8c8d0'}"/>`,
      `<rect x="${LEISTE}" y="${LEISTE}" width="100" height="${iH.toFixed(2)}" fill="#17171b"/>`,
    ];

    if (!plan.ok) {
      teile.push(
        `<text x="${B / 2}" y="${(H / 2).toFixed(2)}" font-size="4.5" fill="#5c5c68" ` +
          `text-anchor="middle" dominant-baseline="central">${T('bildLeer')}</text>`
      );
    } else {
      for (const p of plan.pockets) teile.push(karteZeichnen(p, s));
    }

    teile.push('</svg>');

    // Der Rahmen als Körper: Vorderseite plus die vier Wangen in Bautiefe.
    // Flach gesehen sind sie unsichtbar, beim Neigen geben sie die Tiefe.
    return (
      '<div class="cfk__szene">' +
      teile.join('') +
      '<i class="cfk__wange cfk__wange--links"></i>' +
      '<i class="cfk__wange cfk__wange--rechts"></i>' +
      '<i class="cfk__wange cfk__wange--oben"></i>' +
      '<i class="cfk__wange cfk__wange--unten"></i>' +
      '<i class="cfk__schattenwurf"></i>' +
      '</div>'
    );
  }

  /* Maße in Pixeln setzen. Das SVG steckt in einem Wrapper und kann seine
   * Größe deshalb nicht mehr selbst aus dem Seitenverhältnis ableiten —
   * also rechnen wir sie aus, statt sie zu erraten. */
  function bemassen() {
    const szene = el('bild').querySelector('.cfk__szene');
    if (!szene) return;

    const f = gehaengt();
    const s = 100 / f.w;
    const B = 100 + 2 * LEISTE;
    const H = f.h * s + 2 * LEISTE;

    const bild = el('bild');
    const stil = getComputedStyle(bild);
    const platzB =
      bild.clientWidth - parseFloat(stil.paddingLeft) - parseFloat(stil.paddingRight);
    const platzH = window.innerHeight * (window.innerWidth <= 900 ? 0.46 : 0.58);

    const breite = Math.max(80, Math.min(platzB, platzH * (B / H)));
    const hoehe = breite * (H / B);

    szene.style.width = breite.toFixed(1) + 'px';
    szene.style.height = hoehe.toFixed(1) + 'px';

    // 30 mm Bautiefe, umgerechnet in dieselbe Einheit wie die Zeichnung.
    const tiefeEinheiten = ((KATALOG.regeln.tiefe || 0) * 100) / f.w;
    szene.style.setProperty('--cfk-tiefe', ((tiefeEinheiten / B) * breite).toFixed(1) + 'px');

    const dunkel = istDunkel();
    szene.style.setProperty('--cfk-wange', dunkel ? '#23232a' : '#e3e3e9');
    szene.style.setProperty('--cfk-wange-hell', dunkel ? '#34343d' : '#f4f4f7');
    szene.style.setProperty('--cfk-wange-dunkel', dunkel ? '#131317' : '#c9c9d2');
  }

  /* ---------- Gerüst ---------- */

  const wurzel = document.querySelector('[data-cardframes-konfigurator]');
  if (!wurzel) return;
  wurzel.classList.add('cfk');

  const el = (name) => wurzel.querySelector('[data-' + name + ']');

  function geruestBauen() {
    wurzel.innerHTML = `
      <div class="cfk__buehne">
        <div class="cfk__bild" data-bild></div>
        <div class="cfk__bildfuss">
          <span class="cfk__plaetze" data-plaetze></span>
          <span data-tipp></span>
        </div>
      </div>
      <div>
        <div class="cfk__kopfzeile">
          <div class="cfk__kopf">
            <h2>${T('titel')}</h2>
            <p>${T('untertitel')}</p>
          </div>
          <div data-sprachen></div>
        </div>

        <div class="cfk__schritt">
          <p class="cfk__titel"><span class="cfk__nummer">1</span> ${T('schrittFormat')}</p>
          <div class="cfk__wahl" data-formate></div>
          <div class="cfk__wahl cfk__ausrichtung" data-ausrichtung></div>
        </div>

        <div class="cfk__schritt">
          <p class="cfk__titel"><span class="cfk__nummer">2</span> ${T('schrittFarbe')}</p>
          <div class="cfk__wahl" data-farben></div>
        </div>

        <div class="cfk__schritt">
          <p class="cfk__titel"><span class="cfk__nummer">3</span> ${T('schrittInhalt')}</p>
          <div class="cfk__halter" data-halter></div>
          <div class="cfk__zwischentitel" data-postentitel hidden>
            <span>${T('imRahmen')}</span>
            <button type="button" data-leeren>${T('allesEntfernen')}</button>
          </div>
          <div class="cfk__liste" data-posten></div>
          <div data-hinweis></div>
        </div>

        <div class="cfk__abschluss">
          <div class="cfk__preis">
            <span class="cfk__preis-info" data-zusammenfassung></span>
            <span class="cfk__preis-wert" data-preis></span>
          </div>
          <p class="cfk__versand" data-versand hidden></p>
          <button type="button" class="cfk__kaufen" data-kaufen>${T('kaufen')}</button>
          <ul class="cfk__vertrauen">
            ${T('vertrauen').map((t) => '<li>' + t + '</li>').join('')}
          </ul>
        </div>
      </div>`;

    el('leeren').addEventListener('click', () => {
      zustand.posten = [];
      zustand.drehungen = {};
      el('hinweis').innerHTML = '';
      alles();
    });

    el('kaufen').addEventListener('click', kaufen);
    sprachenZeichnen();
  }

  function sprachenZeichnen() {
    const box = el('sprachen');
    box.innerHTML = '';
    if (!SPRACHWAHL || SPRACHEN.length < 2) return;

    const reihe = document.createElement('div');
    reihe.className = 'cfk__flaggen';
    reihe.setAttribute('role', 'group');
    reihe.setAttribute('aria-label', T('ariaSprache'));

    for (const kuerzel of SPRACHEN) {
      const eintrag = TEXTE[kuerzel];
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'cfk__flagge';
      // Flagge sehen, Sprachnamen lesen: der Name bleibt als Beschriftung
      // erhalten, sonst wäre der Knopf für Vorleseprogramme stumm.
      b.title = eintrag._name;
      b.setAttribute('aria-label', eintrag._name);
      b.setAttribute('aria-pressed', String(kuerzel === zustand.sprache));
      b.innerHTML = eintrag._flagge || '<span>' + kuerzel.toUpperCase() + '</span>';
      b.addEventListener('click', () => {
        if (kuerzel === zustand.sprache) return;
        zustand.sprache = kuerzel;
        geruestBauen();
        alles();
      });
      reihe.appendChild(b);
    }
    box.appendChild(reihe);
  }

  function knopf(inhalt, aktiv, onClick, deaktiviert) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'cfk__knopf';
    b.innerHTML = inhalt;
    b.setAttribute('aria-pressed', String(Boolean(aktiv)));
    b.disabled = Boolean(deaktiviert);
    b.addEventListener('click', onClick);
    return b;
  }

  function formateZeichnen() {
    const box = el('formate');
    box.innerHTML = '';
    for (const f of KATALOG.rahmen) {
      box.appendChild(
        knopf(`${f.name}<small>${euro(preisVon(f))}</small>`, f.id === zustand.rahmen.id, () => {
          zustand.rahmen = f;
          alles();
        })
      );
    }
  }

  /* Hoch oder quer gehängt. Wechselt die Ausrichtung so, dass die Bestückung
   * nicht mehr passt, bleibt sie stehen und der Knopf ist gesperrt — lieber
   * gar nicht umschalten als dem Kunden seine Auswahl zerschießen. */
  function ausrichtungZeichnen() {
    const box = el('ausrichtung');
    box.innerHTML = '';

    [
      { quer: false, text: T('hochformat'), symbol: '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="6.5" y="2.5" width="7" height="15" rx="1"/></svg>' },
      { quer: true, text: T('querformat'), symbol: '<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2.5" y="6.5" width="15" height="7" rx="1"/></svg>' },
    ].forEach((wahl) => {
      const aktiv = wahl.quer === zustand.querformat;
      let machbar = true;
      if (!aktiv && zustand.posten.length) {
        const merk = zustand.querformat;
        zustand.querformat = wahl.quer;
        machbar = rechnen().ok;
        zustand.querformat = merk;
      }
      const b = knopf(
        '<span class="cfk__symbol">' + wahl.symbol + '</span>' + wahl.text,
        aktiv,
        () => {
          zustand.querformat = wahl.quer;
          el('hinweis').innerHTML = '';
          alles();
        },
        !machbar
      );
      b.classList.add('cfk__knopf--symbol');
      box.appendChild(b);
    });
  }

  function farbenZeichnen() {
    const box = el('farben');
    box.innerHTML = '';
    for (const farbe of KATALOG.farben) {
      const punkt = `<span class="cfk__punkt" style="background:${farbe.hex}"></span>`;
      box.appendChild(
        knopf(punkt + farbtext(farbe), farbe.name === zustand.farbe.name, () => {
          zustand.farbe = farbe;
          alles();
        })
      );
    }
  }

  const anzahlVon = (id) => {
    const p = zustand.posten.find((x) => x.halterId === id);
    return p ? p.anzahl : 0;
  };

  function halterZeichnen() {
    const box = el('halter');
    box.innerHTML = '';
    for (const h of KATALOG.halter) {
      const max = window.CardframesLayout.capacity(gehaengt(), h, RAND, STEG, 40);
      const n = anzahlVon(h.id);
      const b = knopf(
        `<strong>${h.name}</strong><small>${max ? T('bis', { n: max }) : T('passtNicht')}</small>`,
        n > 0,
        () => hinzufuegen(h.id),
        max === 0
      );
      if (n > 0) {
        const z = document.createElement('span');
        z.className = 'cfk__zaehler';
        z.textContent = n;
        b.appendChild(z);
      }
      box.appendChild(b);
    }
  }

  function hinzufuegen(halterId) {
    const vorhanden = zustand.posten.find((p) => p.halterId === halterId);
    if (vorhanden) vorhanden.anzahl += 1;
    else zustand.posten.push({ halterId, anzahl: 1 });

    if (!rechnen().ok) {
      // Nicht kommentarlos scheitern lassen: zurücknehmen und Ausweg zeigen.
      aendern(halterId, -1);
      alles();
      empfehlen(halterId);
      return;
    }
    alles();
  }

  function aendern(halterId, delta) {
    const posten = zustand.posten.find((p) => p.halterId === halterId);
    if (!posten) return;
    posten.anzahl += delta;
    if (posten.anzahl <= 0) zustand.posten = zustand.posten.filter((p) => p !== posten);
    aufraeumen();
  }

  /* Drehungen vergessen, deren Karte es nicht mehr gibt. */
  function aufraeumen() {
    const gueltig = new Set();
    for (const p of zustand.posten) {
      for (let i = 1; i <= p.anzahl; i++) gueltig.add(p.halterId + '#' + i);
    }
    for (const k of Object.keys(zustand.drehungen)) {
      if (!gueltig.has(k)) delete zustand.drehungen[k];
    }
  }

  function postenZeichnen() {
    const box = el('posten');
    box.innerHTML = '';
    el('postentitel').hidden = zustand.posten.length === 0;

    for (const posten of zustand.posten) {
      const h = halterVon(posten.halterId);
      const zeile = document.createElement('div');
      zeile.className = 'cfk__zeile';
      zeile.innerHTML = `<b>${h.name}</b><span class="cfk__zeile-fuell"></span>`;

      const menge = document.createElement('div');
      menge.className = 'cfk__menge';

      const minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.setAttribute('aria-label', T('ariaWeniger', { name: h.name }));
      minus.addEventListener('click', () => {
        aendern(posten.halterId, -1);
        alles();
      });

      const zahl = document.createElement('span');
      zahl.textContent = posten.anzahl;

      const plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', T('ariaMehr', { name: h.name }));
      plus.addEventListener('click', () => hinzufuegen(posten.halterId));

      // Vorausschauen: geht einer mehr überhaupt?
      posten.anzahl += 1;
      plus.disabled = !rechnen().ok;
      posten.anzahl -= 1;

      menge.append(minus, zahl, plus);
      zeile.appendChild(menge);

      // Eigener Knopf zum Rauswerfen. Über das Minus bis auf null zu zählen
      // findet niemand, der den Typ einfach tauschen will.
      const weg = document.createElement('button');
      weg.type = 'button';
      weg.className = 'cfk__weg';
      weg.innerHTML = '&times;';
      weg.title = T('ariaEntfernen', { name: h.name });
      weg.setAttribute('aria-label', T('ariaEntfernen', { name: h.name }));
      weg.addEventListener('click', () => {
        zustand.posten = zustand.posten.filter((p) => p !== posten);
        aufraeumen();
        el('hinweis').innerHTML = '';
        alles();
      });
      zeile.appendChild(weg);

      box.appendChild(zeile);
    }
  }

  /* „Passt hier nicht — aber in …" statt einer Sackgasse. */
  function empfehlen(halterId) {
    const box = el('hinweis');
    box.innerHTML = '';

    const probe = zustand.posten.map((p) => ({
      holder: halterVon(p.halterId),
      count: p.anzahl + (p.halterId === halterId ? 1 : 0),
    }));
    if (!probe.some((p) => p.holder.id === halterId)) {
      probe.push({ holder: halterVon(halterId), count: 1 });
    }

    // In der aktuellen Ausrichtung prüfen, sonst empfiehlt er Formate, die
    // quer gehängt gar nicht aufgehen.
    const jetzt = gehaengt();
    const passend = window.CardframesLayout.passendeRahmen(
      KATALOG.rahmen.map((f) => gehaengt(f)),
      probe,
      RAND,
      STEG,
      zustand.drehungen
    ).filter((f) => f.w * f.h > jetzt.w * jetzt.h);

    const hinweis = document.createElement('div');
    hinweis.className = 'cfk__hinweis';
    const titel = document.createElement('strong');
    titel.textContent = passend.length ? T('vollTitel') : T('vollTitel');
    hinweis.appendChild(titel);
    hinweis.append(' ');

    if (!passend.length) {
      hinweis.append(T('vollEnde'));
    } else {
      const auswahl = passend.slice(0, 2);
      // Satz um die anklickbaren Formate herum aufbauen, ohne HTML zu bauen:
      // den Platzhalter durch eine sichtbare Marke ersetzen und daran teilen.
      const MARKE = '@@RAHMEN@@';
      const teile = T('vollMit', { rahmen: MARKE }).split(MARKE);
      hinweis.append(teile[0] || '');
      auswahl.forEach((f, i) => {
        if (i) hinweis.append(T('vollOder'));
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = f.name;
        b.addEventListener('click', () => {
          // Zurück auf den Katalogeintrag: `f` trägt die gehängten Maße,
          // gespeichert wird immer das ungedrehte Format.
          zustand.rahmen = KATALOG.rahmen.find((r) => r.id === f.id) || zustand.rahmen;
          alles();
          hinzufuegen(halterId);
        });
        hinweis.appendChild(b);
      });
      hinweis.append(teile[1] || '');
    }
    box.appendChild(hinweis);
  }

  function istQuer(plan, key) {
    const p = plan.ok && plan.pockets.find((x) => x.key === key);
    return p ? p.rotated : false;
  }

  /* Leichte 3D-Neigung. Bewusst begrenzt: der Rahmen soll sich anfassen
   * lassen, nicht herumwirbeln. Ein Zug von der Karte unterscheidet sich vom
   * Klick über die zurückgelegte Strecke — sonst dreht sich beim Ziehen
   * versehentlich eine Karte. */
  const NEIGUNG_MAX_Y = 16;
  const NEIGUNG_MAX_X = 11;
  const ZIEHSCHWELLE = 5;

  function neigungAnhaengen(szene) {
    let zieht = false;
    let startX = 0;
    let startY = 0;
    let gezogen = 0;
    let ry = 0;
    let rx = 0;

    const setzen = () => {
      szene.style.transform = `rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg)`;
    };
    const klemmen = (wert, grenze) => Math.max(-grenze, Math.min(grenze, wert));

    let gefangen = false;

    szene.addEventListener('pointerdown', (e) => {
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      zieht = true;
      gefangen = false;
      gezogen = 0;
      startX = e.clientX;
      startY = e.clientY;
      // Hier wird der Zeiger bewusst NICHT eingefangen. Ein eingefangener
      // Zeiger stellt den anschließenden Klick auf das Auffangelement um —
      // die Karte bekäme ihn nie, und das Drehen wäre tot. Gefangen wird
      // erst, wenn wirklich gezogen wird.
    });

    szene.addEventListener('pointermove', (e) => {
      if (!zieht) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      gezogen = Math.max(gezogen, Math.hypot(dx, dy));
      if (gezogen <= ZIEHSCHWELLE) return;

      if (!gefangen) {
        gefangen = true;
        szene.classList.add('cfk__zieht');
        try {
          szene.setPointerCapture(e.pointerId);
        } catch (_) {}
      }
      ry = klemmen(dx * 0.22, NEIGUNG_MAX_Y);
      rx = klemmen(-dy * 0.16, NEIGUNG_MAX_X);
      setzen();
    });

    const loslassen = (e) => {
      if (!zieht) return;
      zieht = false;
      gefangen = false;
      szene.classList.remove('cfk__zieht');
      try {
        if (e.pointerId !== undefined && szene.hasPointerCapture(e.pointerId)) {
          szene.releasePointerCapture(e.pointerId);
        }
      } catch (_) {}
      // Zurückfedern in die gerade Ansicht.
      ry = 0;
      rx = 0;
      setzen();
    };
    szene.addEventListener('pointerup', loslassen);
    szene.addEventListener('pointercancel', loslassen);
    szene.addEventListener('pointerleave', loslassen);

    // Wurde gezogen, war es kein Klick auf eine Karte.
    szene.addEventListener(
      'click',
      (e) => {
        if (gezogen > ZIEHSCHWELLE) {
          e.stopPropagation();
          e.preventDefault();
          gezogen = 0;
        }
      },
      true
    );
  }

  function buehneZeichnen() {
    const plan = rechnen();
    el('bild').innerHTML = zeichnen(plan);
    bemassen();
    neigungAnhaengen(el('bild').querySelector('.cfk__szene'));

    el('bild')
      .querySelectorAll('.cfk__karte')
      .forEach((g) => {
        const dreh = () => {
          const key = g.dataset.key;
          const vorher = zustand.drehungen[key];
          zustand.drehungen[key] = !(vorher === undefined ? istQuer(plan, key) : vorher);
          if (!rechnen().ok) {
            // Geht nicht? Dann Zustand zurücknehmen statt kaputt zeigen.
            if (vorher === undefined) delete zustand.drehungen[key];
            else zustand.drehungen[key] = vorher;
            return;
          }
          alles();
        };
        g.addEventListener('click', dreh);
        g.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            dreh();
          }
        });
      });

    const stueck = zustand.posten.reduce((s, p) => s + p.anzahl, 0);
    el('plaetze').textContent = !stueck
      ? T('leer')
      : stueck === 1
      ? T('eineKarte')
      : T('vieleKarten', { n: stueck });
    el('tipp').textContent = stueck ? T('drehTipp') : '';
    el('zusammenfassung').textContent =
      zustand.rahmen.name +
      ' · ' +
      (zustand.querformat ? T('querformat') : T('hochformat')) +
      ' · ' +
      farbtext(zustand.farbe);
    const preis = preisVon(zustand.rahmen);
    el('preis').textContent = euro(preis);
    el('kaufen').disabled = stueck === 0;

    // Versandkostenfrei-Hinweis nur dort, wo die Grenze auch gilt.
    const versandFeld = el('versand');
    const zeigen = VERSAND && LAND === VERSAND.land && preis < VERSAND.ab;
    versandFeld.hidden = !zeigen;
    if (zeigen) {
      versandFeld.textContent = T('versandfrei', {
        betrag: euro(VERSAND.ab),
        rest: euro(VERSAND.ab - preis),
      });
    }
  }

  function alles() {
    aufraeumen();
    formateZeichnen();
    ausrichtungZeichnen();
    farbenZeichnen();
    halterZeichnen();
    postenZeichnen();
    buehneZeichnen();
  }

  /* ---------- Warenkorb ---------- */

  function bestellung() {
    const bestueckung = zustand.posten
      .map((p) => p.anzahl + ' × ' + halterVon(p.halterId).name)
      .join(', ');

    // Sichtbar für den Kunden in seiner Sprache, plus eine verborgene
    // Kurzfassung für die Fertigung. Die ist sprachunabhängig — daran hängt
    // die Schnittdatei, und die darf sich nie mit der Sprache ändern.
    const sichtbar = {};
    sichtbar[T('eigRahmen')] = zustand.rahmen.name;
    sichtbar[T('eigAusrichtung')] = zustand.querformat ? T('querformat') : T('hochformat');
    sichtbar[T('eigFarbe')] = farbtext(zustand.farbe);
    sichtbar[T('eigInhalt')] = bestueckung;

    return {
      sichtbar,
      verborgen: {
        _konfig: JSON.stringify({
          r: zustand.rahmen.id,
          q: zustand.querformat,
          f: zustand.farbe.name,
          p: zustand.posten.map((p) => [p.halterId, p.anzahl]),
          d: zustand.drehungen,
          k: KATALOG.stand,
          s: zustand.sprache,
        }),
      },
    };
  }

  async function kaufen() {
    const b = bestellung();

    if (!VARIANTEN) {
      const box = el('hinweis');
      box.innerHTML = '';
      const kasten = document.createElement('div');
      kasten.className = 'cfk__hinweis';
      kasten.innerHTML =
        '<strong>Entwurf — kein Shop angebunden.</strong><br>An den Warenkorb ginge:<br>' +
        Object.entries(b.sichtbar).map(([k, v]) => k + ': ' + v).join('<br>') +
        '<br><br>verborgen: <code>' + b.verborgen._konfig + '</code>';
      box.appendChild(kasten);
      return;
    }

    const variante = VARIANTEN[variantenschluessel(zustand.rahmen)];
    if (!variante) return;

    const knopfEl = el('kaufen');
    knopfEl.disabled = true;
    knopfEl.textContent = T('kaufenLaeuft');

    try {
      const antwort = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: variante.id,
              quantity: 1,
              properties: Object.assign({}, b.sichtbar, b.verborgen),
            },
          ],
        }),
      });
      // Lehnt der Warenkorb ab, den Grund von Shopify mitnehmen. Eine
      // Meldung ohne Grund hilft weder beim Suchen noch dem Kunden.
      if (!antwort.ok) {
        let grund = 'HTTP ' + antwort.status;
        try {
          const daten = await antwort.json();
          grund = daten.description || daten.message || grund;
        } catch (_) {}
        throw new Error(grund);
      }
      window.location.href = '/checkout';
    } catch (e) {
      knopfEl.disabled = false;
      knopfEl.textContent = T('kaufen');
      const grund = e && e.message ? '<br><small>' + e.message + '</small>' : '';
      el('hinweis').innerHTML =
        '<div class="cfk__hinweis">' + T('kaufenFehler') + grund + '</div>';
    }
  }

  // Einmalig: bei Größenänderung des Fensters neu bemaßen.
  let bemessenGeplant = null;
  window.addEventListener('resize', () => {
    clearTimeout(bemessenGeplant);
    bemessenGeplant = setTimeout(bemassen, 120);
  });

  geruestBauen();
  alles();
})();
